import GiftLoadError from '@activities/gift/_shared/components/GiftLoadError';
import BlankEtc from '@components/blank/BlankEtc';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import GiftBoxItemSkeletons from './components/GiftBoxItemSkeletons';
import SentGiftItem from './components/SentGiftItem';
import useSentGiftBoxes from './hooks/useSentGiftBoxes';

function SentGiftBoxFragment() {
    const { t } = useTranslation('gift');
    const {
        gifts, isEmpty, isFetching, fetchNextPage, hasNextPage, isError, isFetchNextPageError, refetch,
    } = useSentGiftBoxes();

    return (
        <Section aria-label={t('giftBox.sent')}>
            {isError && (
                <GiftLoadError message={t('giftBox.loadError')} isFetching={isFetching}
                    onRetry={() => (isFetchNextPageError ? fetchNextPage() : refetch())} />
            )}
            {isEmpty && !isFetching && !isError ? (
                <BlankEtc>
                    <Text size='body-short' color={colors.textSecondary} fontWeight='regular' align='center'>
                        {t('blank.sendSubtitle')}<br />{t('blank.send')}
                    </Text>
                </BlankEtc>
            ) : (
                <List>
                    {gifts.map((gift) => (
                        <SentGiftItem key={gift.id} gift={gift} />
                    ))}
                    {isFetching && <GiftBoxItemSkeletons count={gifts.length ? 1 : 5} />}
                    {hasNextPage && !isFetching && !isError && (
                        <InfinityScrollTrigger trigger={() => fetchNextPage()} />
                    )}
                </List>
            )}
        </Section>
    );
}

const Section = styled.section`
    width: 100%;
`;

const List = styled.div`
    display: flex;
    flex-direction: column;
    gap: var(--spacing-6);
    padding: var(--spacing-4) var(--spacing-4) var(--spacing-10);
`;

export default SentGiftBoxFragment;
